import { connect } from 'react-redux';
import { loadReseller } from 'redux/actions/layoutActions';
import Login from './Login';

const mapStateToProps = ({ layout }) => {
    const { admin, locale, reseller, userData } = layout;
    return { admin, locale, reseller, userData };
};

const mapDispatchToProps = { loadReseller };

export default connect(mapStateToProps, mapDispatchToProps)(Login);
